import React from 'react';
import { DocPageLayout } from '../../components/DocPageLayout';
import { CodeBlock } from '../../components/CodeBlock';
export function ApiGatewayPage() {
  return <DocPageLayout title="Gateway API" description="Operations related to speaking directly to the Gateway for status or payment option related details." breadcrumbs={[{
    label: 'API Reference',
    id: 'api-overview'
  }, {
    label: 'Gateway'
  }]} sections={[{
    id: 'gateway-info',
    title: 'Gateway Information'
  }, {
    id: 'payment-options',
    title: 'Payment Options Inquiry'
  }]} data-id="element-535">
      <h2 id="gateway-info" className="text-2xl font-bold text-gray-900 mt-6 mb-4 border-b border-gray-200 pb-2" data-id="element-536">
        Gateway Information
      </h2>
      <div className="bg-gray-50 p-4 rounded-lg border border-gray-200 mb-6 font-mono text-sm" data-id="element-537">
        <span className="inline-block px-2 py-0.5 rounded-full text-xs font-bold bg-green-100 text-green-700 mr-2" data-id="element-538">
          GET
        </span>
        <span className="text-gray-600" data-id="element-539">/information</span>
      </div>
      <p className="text-gray-700 mb-4" data-id="element-540">
        Returns information about the gateway including the current API version,
        supported features, and server status.
      </p>
      <CodeBlock language="JSON" title="Response" code={`{
  "gatewayVersion": "100",
  "apiVersions": ["98", "99", "100"],
  "status": "OPERATING",
  "features": [
    "3DS2", "TOKENIZATION", "BATCH",
    "BROWSER_PAYMENT", "HOSTED_CHECKOUT",
    "RECURRING", "RISK_ASSESSMENT"
  ]
}`} data-id="element-541" />

      <h2 id="payment-options" className="text-2xl font-bold text-gray-900 mt-10 mb-4 border-b border-gray-200 pb-2" data-id="element-542">
        Payment Options Inquiry
      </h2>
      <div className="bg-gray-50 p-4 rounded-lg border border-gray-200 mb-6 font-mono text-sm" data-id="element-543">
        <span className="inline-block px-2 py-0.5 rounded-full text-xs font-bold bg-green-100 text-green-700 mr-2" data-id="element-544">
          GET
        </span>
        <span className="text-gray-600" data-id="element-545">/merchant/</span>
        <span className="text-blue-600" data-id="element-546">{'{merchantId}'}</span>
        <span className="text-gray-600" data-id="element-547">/paymentOptionsInquiry</span>
      </div>
      <p className="text-gray-700 mb-4" data-id="element-548">
        Returns the payment options available for a specific merchant, including
        supported card brands, currencies, and payment methods.
      </p>
      <CodeBlock language="JSON" title="Response" code={`{
  "merchant": "TEST12345678",
  "paymentTypes": [
    {
      "cardBrand": "MASTERCARD",
      "cardType": ["CREDIT", "DEBIT"],
      "currencies": ["USD", "EUR", "GBP"]
    },
    {
      "cardBrand": "VISA",
      "cardType": ["CREDIT", "DEBIT"],
      "currencies": ["USD", "EUR", "GBP"]
    }
  ],
  "browserPayments": ["PAYPAL", "ALIPAY"],
  "wallets": ["APPLE_PAY", "GOOGLE_PAY"]
}`} data-id="element-549" />
    </DocPageLayout>;
}